
(function () {
  
  const SOLO_EN_APP = false;
  const ES_APP = /Reskyt| wv; |Crosswalk/i.test(navigator.userAgent) || !!window.ReactNativeWebView;
  if (SOLO_EN_APP && !ES_APP) return;

  function init() {
    var cart = document.getElementById('quick-cart');
    if (!cart) return;

    
    cart.classList.remove('active', 'qc-allow');
    cart.style.setProperty('display', 'none', 'important');

  
    var until = Date.now() + 2000;
    var guard = new MutationObserver(function () {
      if (Date.now() < until && cart.classList.contains('active')) {
        cart.classList.remove('active');
        cart.style.setProperty('display', 'none', 'important');
      }
    });
    guard.observe(cart, { attributes: true, attributeFilter: ['class', 'style'] });

   
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('.mobile-plus-icon');
      if (!opener) return;

      cart.classList.add('qc-allow'); 
      cart.style.removeProperty('display');
      cart.style.removeProperty('opacity');
      cart.style.removeProperty('pointer-events');
      guard.disconnect(); 
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
